const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const parseNonNegativeInteger = (value) => {
  const isIntegerString =
    typeof value === 'string' && /^\d+$/.test(value.trim());
  if (typeof value !== 'number' && !isIntegerString) return null;

  const numericValue = Number(value);
  if (!Number.isSafeInteger(numericValue) || numericValue < 0) return null;

  return numericValue;
};

const firstValidCount = (...values) => {
  for (const value of values) {
    const count = parseNonNegativeInteger(value);
    if (count !== null) return count;
  }

  return 0;
};

export const normalizeExportJob = (row) => {
  if (!row || typeof row !== 'object' || Array.isArray(row)) return null;

  const exportJobId =
    typeof row.export_job_id === 'string' ? row.export_job_id.trim() : '';
  if (!UUID_PATTERN.test(exportJobId)) return null;

  const nestedProgress =
    row.progress && typeof row.progress === 'object' && !Array.isArray(row.progress)
      ? row.progress
      : {};
  const total = firstValidCount(nestedProgress.total, row.total_jobs);
  const processed = Math.min(
    firstValidCount(nestedProgress.processed, row.processed_jobs),
    total
  );
  const failed = Math.min(
    firstValidCount(nestedProgress.failed, row.failed_jobs),
    total - processed
  );
  const reportedCompleted = firstValidCount(nestedProgress.completed);
  const completed = Math.min(
    Math.max(reportedCompleted, processed + failed),
    total
  );
  const percentage =
    total > 0 ? Math.min(100, Math.floor((completed / total) * 100)) : 0;

  return {
    ...row,
    export_job_id: exportJobId,
    error_message:
      typeof row.error_message === 'string' ? row.error_message : '',
    progress: {
      processed,
      failed,
      total,
      completed,
      percentage,
    },
  };
};

export const normalizeExportJobsResponse = (response) => {
  const rows = Array.isArray(response)
    ? response
    : Array.isArray(response?.jobs)
      ? response.jobs
      : [];
  const jobs = [
    ...new Map(
      rows
        .map(normalizeExportJob)
        .filter(Boolean)
        .map((job) => [job.export_job_id, job])
    ).values(),
  ];
  const reportedTotal = firstValidCount(response?.total);

  return {
    jobs,
    total:
      rows.length === 0
        ? reportedTotal
        : jobs.length > 0
          ? Math.max(jobs.length, reportedTotal)
          : 0,
  };
};
